import { Box } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DashboardNavBar from '../../Components/DashboardNavbar/DashboardNavbar';

function Register() {

    const [ accountType, setAccountType ] = useState();
    const [ email, setEmail ] = useState();
    const [ ucfid, setUcfId ] = useState();
    const [ user, setUser ] = useState();
    
    const navigate = useNavigate();

    const handleRegister = async event => {
        event.preventDefault();
        // event.stopPropogation()

        if(ucfid.value.length < 6){
            event.preventDefault();
            // event.stopPropogation()
            alert("UCF ID has Invalid Entry")
            return
        }
        var obj = {
            ucfid: ucfid.value,
            type: accountType.value,
            email: email.value,
        };
        const access_code = await axios.post(`${process.env.REACT_APP_API_HOST}/api/auth/registerUser`,
                            {ucfid: ucfid.value, type: accountType.value, email: email.value}, 
                            {
                                headers: {Authorization: `Bearer ${user.access_token}`}
                            })

        const subjectLine = 'Invite to Senior Design Portal';
        
        const message = 
        `You have been pre-registered as a ${accountType.value} on the Senior Design Portal. Please follow the link to complete registration: \n
        ${process.env.REACT_APP_SITE_HOST}/finalizeRegistration/${access_code.data}`;
        // window.location.href = `mailto:${email.value}?subject=${subjectLine}&body=${message}`;
        // window.open(`mailto:${email.value}?subject=${subjectLine}&body=${message}`)
        navigate("/classselect")

    }

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        setUser(userData)
        if(userData === undefined || userData === null){
            navigate("/placeholder")
        }
    }, []);

    return (
        <Box >
        <DashboardNavBar userType="admin"/>
                <div className='loginSection' style={{alignContent:'center', justifyContent:'center'}}>

                    <p>Invite User</p>
                    <form onSubmit = {handleRegister} autoComplete="off">
                    <input type="email" className="emailField" placeholder="Email" ref ={(c) => setEmail(c)} required/><br/>
                    <input type="text" className="ucfIdField" placeholder="UCF ID" ref ={(c) => setUcfId(c)} required/><br/>
                        <select className="loginField" name="Account Type" ref ={(c) => setAccountType(c)} required>
                            <option value='admin'>Coordinator</option>
                            <option value='student'>Student</option>
                            <option value='coordinator'>Advisor</option>
                        </select><br/>
                        <input type="submit" className="UCFbutton" 
                        // onClick={handleRegister}
                        />
                        <br/>
                    </form>
                </div>
        </Box>

    )
}

export default Register